// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Job Postings Modal Styles */
.job-postings-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(12px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10001;
  padding: 1rem;
}

.job-postings-modal {
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 32px 64px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.1);
  max-width: 1200px;
  width: 100%;
  max-height: 95vh;
  display: flex;
  flex-direction: column;
  animation: job-postings-slide-in 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

@keyframes job-postings-slide-in {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(30px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.job-postings-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2.5rem 2rem;
  background: linear-gradient(135deg, #1b2c5a 0%, #2d4a7c 50%, #162844 100%);
  color: white;
  position: relative;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.job-postings-powered-by {
  display: flex;
  align-items: center;
  margin-right: 1rem;
}

.job-postings-logo {
  height: 80px;
  width: auto;
  max-width: 400px;
  object-fit: contain;
  filter: brightness(1.1) contrast(1.05);
  transition: opacity 0.2s ease;
}

.job-postings-logo:hover {
  opacity: 0.9;
}

.job-postings-modal-title {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.job-postings-title-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.job-postings-title-content h2 {
  font-size: 1.875rem;
  font-weight: 700;
  margin: 0;
  font-family: 'Anton', sans-serif;
  letter-spacing: 0.5px;
  background: linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.job-postings-modal-subtitle {
  margin: 0.5rem 0 0 0;
  font-size: 1rem;
  opacity: 0.9;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.8);
}

.job-postings-modal-close {
  padding: 0.75rem 1.5rem;
  background: #d5a32a;
  color: #ffffff;
  border-radius: 0.75rem;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.875rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  font-family: 'Roboto', sans-serif;
}

.job-postings-modal-close:hover {
  background: #f2c94c;
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
}

.job-postings-modal-close:active {
  transform: translateY(0);
}

.job-postings-header-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.job-postings-view-saved-button {
  padding: 0.75rem 1.5rem;
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 0.75rem;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.875rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  backdrop-filter: blur(10px);
  font-family: 'Roboto', sans-serif;
}

.job-postings-view-saved-button:hover {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border-color: rgba(255, 255, 255, 0.3);
  transform: translateY(-1px);
}

.job-postings-view-saved-button.active {
  background: linear-gradient(135deg, #d5a32a 0%, #f2c94c 100%);
  color: white;
  border-color: #d5a32a;
}

.job-postings-view-saved-button.active:hover {
  background: linear-gradient(135deg, #f2c94c 0%, #d5a32a 100%);
  border-color: #f2c94c;
}

.job-postings-download-button {
  padding: 0.75rem 1.5rem;
  background: linear-gradient(135deg, #28a745 0%, #218838 100%);
  color: white;
  border: none;
  border-radius: 0.75rem;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.875rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);
  font-family: 'Roboto', sans-serif;
}

.job-postings-download-button:hover {
  background: linear-gradient(135deg, #218838 0%, #1e7e34 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.4);
}

.job-postings-modal-filters {
  padding: 1.5rem 2rem;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  gap: 1.5rem;
  align-items: end;
  flex-wrap: wrap;
}

.job-postings-filter-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 200px;
}

.job-postings-filter-group label {
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.25rem;
}

.job-postings-filter-input,
.job-postings-filter-select {
  padding: 0.75rem 1rem;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 0.875rem;
  background: white;
  transition: all 0.2s ease;
  outline: none;
}

.job-postings-filter-input:focus,
.job-postings-filter-select:focus {
  border-color: #1b2c5a;
  box-shadow: 0 0 0 3px rgba(27, 44, 90, 0.1);
}

.job-postings-search-button {
  background: linear-gradient(135deg, #1b2c5a 0%, #162844 100%);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  height: fit-content;
}

.job-postings-search-button:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(27, 44, 90, 0.3);
}

.job-postings-search-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.job-postings-modal-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 0;
}

.job-postings-loading,
.job-postings-error,
.job-postings-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  text-align: center;
  color: #6b7280;
}

.job-postings-loading svg,
.job-postings-error svg,
.job-postings-empty svg {
  margin-bottom: 1rem;
  opacity: 0.6;
}

.job-postings-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #e2e8f0;
  border-top: 3px solid #1b2c5a;
  border-radius: 50%;
  animation: job-postings-spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes job-postings-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.job-postings-error {
  color: #dc2626;
}

.job-postings-retry-button {
  background: #dc2626;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  cursor: pointer;
  margin-top: 1rem;
  transition: background 0.2s ease;
}

.job-postings-retry-button:hover {
  background: #b91c1c;
}

.job-postings-results {
  padding: 0;
}

.job-postings-results-header {
  padding: 1.5rem 2rem 1rem 2rem;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
}

.job-postings-results-header h3 {
  margin: 0;
  font-size: 1.125rem;
  font-weight: 600;
  color: #374151;
}

.job-postings-load-more-container {
  padding: 1.5rem 2rem 2rem 2rem;
  display: flex;
  justify-content: center;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
}

.job-postings-load-more {
  background: linear-gradient(135deg, #1b2c5a 0%, #162844 100%);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.job-postings-load-more:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(27, 44, 90, 0.3);
}

.job-postings-load-more:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.job-postings-list {
  padding: 1.5rem 2rem 2rem 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.job-posting-card {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 2rem;
  margin-bottom: 1.5rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05), 0 1px 3px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
}

.job-posting-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #d5a32a 0%, #f2c94c 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.job-posting-card:hover {
  border-color: #d5a32a;
  box-shadow: 0 8px 25px rgba(213, 163, 42, 0.15), 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-4px);
}

.job-posting-card:hover::before {
  opacity: 1;
}

.job-posting-card-header {
  margin-bottom: 1.5rem;
}

.job-posting-main-info {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
}

.job-posting-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
}

.job-posting-title-section {
  flex: 1 1;
}

.job-posting-title {
  margin: 0 0 0.5rem 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: #1f2937;
  line-height: 1.3;
}

.job-posting-company {
  font-size: 1rem;
  font-weight: 600;
  color: #1b2c5a;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.job-posting-badges {
  display: flex;
  gap: 0.75rem;
  align-items: center;
}

.job-posting-distance-badge {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  color: #475569;
  padding: 0.5rem 0.75rem;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.375rem;
  border: 1px solid #cbd5e1;
}

.job-posting-featured-badge {
  background: linear-gradient(135deg, #d5a32a 0%, #f2c94c 100%);
  color: white;
  padding: 0.5rem 0.75rem;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.375rem;
  box-shadow: 0 2px 4px rgba(213, 163, 42, 0.3);
  cursor: help;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  white-space: nowrap;
}

.job-posting-featured-badge:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(213, 163, 42, 0.4);
}

.job-posting-badge {
  background: linear-gradient(135deg, #1b2c5a 0%, #162844 100%);
  color: white;
  padding: 0.5rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
  margin-left: 1rem;
}

.job-posting-meta-info {
  display: flex;
  gap: 1.5rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
}

.job-posting-meta-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #6b7280;
  font-size: 0.875rem;
}

.job-posting-meta-item svg {
  opacity: 0.7;
}

.job-posting-description {
  margin-bottom: 1.5rem;
  background: #f8fafc;
  border-radius: 12px;
  padding: 1.5rem;
  border: 1px solid #e2e8f0;
}

.job-posting-description-header {
  margin-bottom: 1rem;
}

.job-posting-description-header h5 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #1b2c5a;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.job-posting-description-header h5::before {
  content: '📋';
  font-size: 1.125rem;
}

.job-posting-description-content {
  color: #4b5563;
  line-height: 1.6;
}

.job-posting-description-content p {
  margin: 0;
  font-size: 0.95rem;
}

.job-posting-description p.expanded {
  display: block;
}

.job-posting-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.job-posting-secondary-actions {
  display: flex;
  gap: 0.5rem;
}

.job-posting-save-button,
.job-posting-share-button {
  padding: 0.75rem;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.job-posting-save-button:hover,
.job-posting-share-button:hover {
  background: #e2e8f0;
  color: #475569;
  border-color: #cbd5e1;
  transform: translateY(-1px);
}

.job-posting-save-button.saved {
  background: linear-gradient(135deg, #d5a32a 0%, #f2c94c 100%);
  color: white;
  border-color: #d5a32a;
}

.job-posting-save-button.saved:hover {
  background: linear-gradient(135deg, #f2c94c 0%, #d5a32a 100%);
  color: white;
  border-color: #f2c94c;
  transform: translateY(-1px);
}

.job-posting-apply-button {
  background: linear-gradient(135deg, #d5a32a 0%, #f2c94c 100%);
  color: white;
  text-decoration: none;
  padding: 0.875rem 2rem;
  border-radius: 12px;
  font-size: 0.95rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(213, 163, 42, 0.3);
  border: none;
  cursor: pointer;
}

.job-posting-apply-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(213, 163, 42, 0.4);
  background: linear-gradient(135deg, #f2c94c 0%, #d5a32a 100%);
  text-decoration: none;
  color: white;
}

.job-posting-apply-button:active {
  transform: translateY(0);
}

/* Responsive Design */
@media (max-width: 768px) {
  .job-postings-modal-overlay {
    padding: 0.25rem;
  }

  .job-postings-modal {
    max-width: 100vw;
    max-height: 99vh;
    margin: 0;
    border-radius: 8px;
    height: 99vh;
  }
  
  .job-postings-modal-header {
    padding: 0.5rem;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
    flex-shrink: 0;
  }

  .job-postings-modal-title {
    width: 100%;
    gap: 0.75rem;
  }

  .job-postings-title-icon {
    width: 28px;
    height: 28px;
    border-radius: 6px;
  }

  .job-postings-title-icon svg {
    width: 14px;
    height: 14px;
  }
  
  .job-postings-title-content h2 {
    font-size: 1rem;
  }

  .job-postings-modal-subtitle {
    font-size: 0.7rem;
    margin: 0.15rem 0 0 0;
  }

  .job-postings-header-actions {
    width: 100%;
    justify-content: space-between;
    gap: 0.25rem;
  }

  .job-postings-modal-close,
  .job-postings-view-saved-button {
    padding: 0.35rem 0.75rem;
    font-size: 0.65rem;
    flex: 1 1;
    justify-content: center;
  }

  .job-postings-download-button {
    padding: 0.35rem 0.75rem;
    font-size: 0.65rem;
    flex: 1 1;
    justify-content: center;
  }
  
  .job-postings-modal-filters {
    padding: 0.25rem 0.5rem;
    flex-direction: column;
    align-items: stretch;
    gap: 0.25rem;
    flex-shrink: 0;
    transition: all 0.3s ease;
    background: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
  }

  /* Minimized filters when scrolling */
  .job-postings-modal-filters.minimized {
    padding: 0.25rem 0.75rem;
    gap: 0.25rem;
    position: sticky;
    top: 0;
    z-index: 10;
    backdrop-filter: blur(8px);
    background: rgba(248, 250, 252, 0.95);
    border-bottom: 1px solid rgba(226, 232, 240, 0.8);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .job-postings-modal-filters.minimized .job-postings-filter-group {
    display: none;
  }

  .job-postings-modal-filters.minimized .job-postings-filter-group:first-child,
  .job-postings-modal-filters.minimized .job-postings-filter-group:last-child {
    display: flex;
  }

  .job-postings-modal-filters.minimized .job-postings-filter-group:first-child {
    flex-direction: row;
    gap: 0.5rem;
    align-items: center;
  }

  .job-postings-modal-filters.minimized .job-postings-filter-group:first-child label {
    font-size: 0.7rem;
    margin: 0;
  }

  .job-postings-modal-filters.minimized .job-postings-filter-group:first-child input {
    width: 60px;
    padding: 0.25rem 0.5rem;
    font-size: 0.7rem;
  }

  .job-postings-modal-filters.minimized .job-postings-filter-group:first-child span {
    font-size: 0.7rem;
  }

  .job-postings-modal-filters.minimized .job-postings-search-button {
    padding: 0.4rem 0.8rem;
    font-size: 0.7rem;
    width: auto;
    flex: 0 0 auto;
  }

  .job-postings-filter-group {
    min-width: auto;
  }

  .job-postings-filter-group label {
    font-size: 0.65rem;
  }

  .job-postings-filter-input,
  .job-postings-filter-select {
    padding: 0.35rem 0.5rem;
    font-size: 0.7rem;
  }

  .job-postings-search-button {
    padding: 0.4rem 0.75rem;
    font-size: 0.7rem;
    width: 100%;
    justify-content: center;
  }

  .job-postings-results-header {
    padding: 0.5rem;
    flex-shrink: 0;
  }

  .job-postings-results-header h3 {
    font-size: 0.8rem;
  }
  
  .job-postings-list {
    padding: 0.25rem;
    gap: 0.25rem;
    flex: 1 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  
  .job-posting-card {
    padding: 0.5rem;
    border-radius: 6px;
    margin-bottom: 0;
    flex-shrink: 0;
  }

  .job-posting-card-header {
    margin-bottom: 0.5rem;
  }

  .job-posting-main-info {
    flex-direction: column;
    gap: 0.25rem;
    margin-bottom: 0.25rem;
  }

  .job-posting-title {
    font-size: 0.9rem;
    margin: 0 0 0.2rem 0;
  }

  .job-posting-company {
    font-size: 0.75rem;
    margin-bottom: 0.2rem;
  }

  .job-posting-badges {
    gap: 0.25rem;
    flex-wrap: wrap;
  }

  .job-posting-distance-badge,
  .job-posting-featured-badge,
  .job-posting-badge {
    font-size: 0.6rem;
    padding: 0.2rem 0.4rem;
    margin-left: 0;
  }
  
  .job-posting-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  
  .job-posting-badge {
    margin-left: 0;
    align-self: flex-start;
  }
  
  .job-posting-meta-info {
    flex-direction: column;
    gap: 0.25rem;
    margin-bottom: 0.5rem;
  }

  .job-posting-meta-item {
    font-size: 0.65rem;
  }

  .job-posting-meta-item svg {
    width: 12px;
    height: 12px;
  }

  .job-posting-description {
    padding: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .job-posting-description-header h5 {
    font-size: 0.75rem;
  }

  .job-posting-description-content p {
    font-size: 0.7rem;
    line-height: 1.4;
  }
  
  .job-posting-actions {
    flex-direction: column-reverse;
    gap: 0.25rem;
  }

  .job-posting-secondary-actions {
    width: 100%;
    gap: 0.25rem;
  }

  .job-posting-save-button,
  .job-posting-share-button {
    flex: 1 1;
    padding: 0.4rem;
  }

  .job-posting-save-button svg,
  .job-posting-share-button svg {
    width: 14px;
    height: 14px;
  }
  
  .job-posting-apply-button {
    width: 100%;
    justify-content: center;
    padding: 0.5rem 1rem;
    font-size: 0.75rem;
  }

  .job-postings-load-more-container {
    padding: 0.75rem;
  }

  .job-postings-load-more {
    width: 100%;
    justify-content: center;
    padding: 0.5rem 1rem;
    font-size: 0.75rem;
  }

  .job-postings-powered-by {
    margin-right: 0.25rem;
  }

  .job-postings-logo {
    height: 40px;
    max-width: 200px;
  }

  .radius-tooltip {
    width: calc(100vw - 3rem) !important;
    max-width: 280px !important;
    font-size: 0.75rem !important;
    padding: 0.75rem !important;
  }
}

/* Saved Jobs Styling */
.job-postings-saved-subtitle {
  margin: 0.25rem 0 0 0;
  font-size: 0.875rem;
  opacity: 0.8;
  font-weight: 400;
}

.job-posting-saved-badge {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  padding: 0.5rem 0.75rem;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.375rem;
  box-shadow: 0 2px 4px rgba(16, 185, 129, 0.3);
}

.saved-job-card {
  border-left: 4px solid #10b981;
}

.saved-job-card::before {
  background: linear-gradient(90deg, #10b981 0%, #059669 100%);
}
`, "",{"version":3,"sources":["webpack://./src/components/JobPostingsModal.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,8EAA8E;EAC9E,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mEAAmE;EACnE,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,0EAA0E;EAC1E,YAAY;EACZ,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,gCAAgC;EAChC,qBAAqB;EACrB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,wCAAwC;EACxC,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,+BAA+B;EAC/B,0CAA0C;EAC1C,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,4CAA4C;EAC5C,iCAAiC;AACnC;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;AACf;;AAEA;;EAEE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,iDAAiD;EACjD,uEAAuE;EACvE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4DAA4D;EAC5D,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,8EAA8E;EAC9E,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,6CAA6C;EAC7C,YAAY;EACZ,qDAAqD;EACrD,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iDAAiD;EACjD,8CAA8C;EAC9C,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,6DAA6D;EAC7D,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,sBAAsB;AACtB;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,8BAA8B;IAC9B,YAAY;EACd;;EAEA;;IAEE,wBAAwB;IACxB,kBAAkB;IAClB,SAAO;IACP,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,SAAO;IACP,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;IACZ,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA,qCAAqC;EACrC;IACE,wBAAwB;IACxB,YAAY;IACZ,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,0BAA0B;IAC1B,qCAAqC;IACrC,iDAAiD;IACjD,wCAAwC;EAC1C;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;IACjB,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,SAAO;IACP,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;;;IAGE,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,cAAc;IACd,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;IAC9B,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,SAAO;IACP,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,oCAAoC;IACpC,2BAA2B;IAC3B,6BAA6B;IAC7B,2BAA2B;EAC7B;AACF;;AAEA,uBAAuB;AACvB;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4DAA4D;AAC9D","sourcesContent":["/* Job Postings Modal Styles */\n.job-postings-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  backdrop-filter: blur(12px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10001;\n  padding: 1rem;\n}\n\n.job-postings-modal {\n  background: #ffffff;\n  border-radius: 20px;\n  box-shadow: 0 32px 64px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.1);\n  max-width: 1200px;\n  width: 100%;\n  max-height: 95vh;\n  display: flex;\n  flex-direction: column;\n  animation: job-postings-slide-in 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n@keyframes job-postings-slide-in {\n  from {\n    opacity: 0;\n    transform: scale(0.95) translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n.job-postings-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 2.5rem 2rem;\n  background: linear-gradient(135deg, #1b2c5a 0%, #2d4a7c 50%, #162844 100%);\n  color: white;\n  position: relative;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.job-postings-powered-by {\n  display: flex;\n  align-items: center;\n  margin-right: 1rem;\n}\n\n.job-postings-logo {\n  height: 80px;\n  width: auto;\n  max-width: 400px;\n  object-fit: contain;\n  filter: brightness(1.1) contrast(1.05);\n  transition: opacity 0.2s ease;\n}\n\n.job-postings-logo:hover {\n  opacity: 0.9;\n}\n\n.job-postings-modal-title {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.job-postings-title-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  background: rgba(255, 255, 255, 0.15);\n  border-radius: 12px;\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.job-postings-title-content h2 {\n  font-size: 1.875rem;\n  font-weight: 700;\n  margin: 0;\n  font-family: 'Anton', sans-serif;\n  letter-spacing: 0.5px;\n  background: linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.job-postings-modal-subtitle {\n  margin: 0.5rem 0 0 0;\n  font-size: 1rem;\n  opacity: 0.9;\n  font-weight: 400;\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.job-postings-modal-close {\n  padding: 0.75rem 1.5rem;\n  background: #d5a32a;\n  color: #ffffff;\n  border-radius: 0.75rem;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 0.875rem;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  font-family: 'Roboto', sans-serif;\n}\n\n.job-postings-modal-close:hover {\n  background: #f2c94c;\n  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);\n  transform: translateY(-1px);\n}\n\n.job-postings-modal-close:active {\n  transform: translateY(0);\n}\n\n.job-postings-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.job-postings-view-saved-button {\n  padding: 0.75rem 1.5rem;\n  background: rgba(255, 255, 255, 0.1);\n  color: rgba(255, 255, 255, 0.9);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 0.75rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 0.875rem;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  backdrop-filter: blur(10px);\n  font-family: 'Roboto', sans-serif;\n}\n\n.job-postings-view-saved-button:hover {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  border-color: rgba(255, 255, 255, 0.3);\n  transform: translateY(-1px);\n}\n\n.job-postings-view-saved-button.active {\n  background: linear-gradient(135deg, #d5a32a 0%, #f2c94c 100%);\n  color: white;\n  border-color: #d5a32a;\n}\n\n.job-postings-view-saved-button.active:hover {\n  background: linear-gradient(135deg, #f2c94c 0%, #d5a32a 100%);\n  border-color: #f2c94c;\n}\n\n.job-postings-download-button {\n  padding: 0.75rem 1.5rem;\n  background: linear-gradient(135deg, #28a745 0%, #218838 100%);\n  color: white;\n  border: none;\n  border-radius: 0.75rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 0.875rem;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);\n  font-family: 'Roboto', sans-serif;\n}\n\n.job-postings-download-button:hover {\n  background: linear-gradient(135deg, #218838 0%, #1e7e34 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.4);\n}\n\n.job-postings-modal-filters {\n  padding: 1.5rem 2rem;\n  background: #f8fafc;\n  border-bottom: 1px solid #e2e8f0;\n  display: flex;\n  gap: 1.5rem;\n  align-items: end;\n  flex-wrap: wrap;\n}\n\n.job-postings-filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  min-width: 200px;\n}\n\n.job-postings-filter-group label {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 0.25rem;\n}\n\n.job-postings-filter-input,\n.job-postings-filter-select {\n  padding: 0.75rem 1rem;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  background: white;\n  transition: all 0.2s ease;\n  outline: none;\n}\n\n.job-postings-filter-input:focus,\n.job-postings-filter-select:focus {\n  border-color: #1b2c5a;\n  box-shadow: 0 0 0 3px rgba(27, 44, 90, 0.1);\n}\n\n.job-postings-search-button {\n  background: linear-gradient(135deg, #1b2c5a 0%, #162844 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 0.75rem 1.5rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  height: fit-content;\n}\n\n.job-postings-search-button:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(27, 44, 90, 0.3);\n}\n\n.job-postings-search-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.job-postings-modal-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0;\n}\n\n.job-postings-loading,\n.job-postings-error,\n.job-postings-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem 2rem;\n  text-align: center;\n  color: #6b7280;\n}\n\n.job-postings-loading svg,\n.job-postings-error svg,\n.job-postings-empty svg {\n  margin-bottom: 1rem;\n  opacity: 0.6;\n}\n\n.job-postings-spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid #e2e8f0;\n  border-top: 3px solid #1b2c5a;\n  border-radius: 50%;\n  animation: job-postings-spin 1s linear infinite;\n  margin-bottom: 1rem;\n}\n\n@keyframes job-postings-spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.job-postings-error {\n  color: #dc2626;\n}\n\n.job-postings-retry-button {\n  background: #dc2626;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n  cursor: pointer;\n  margin-top: 1rem;\n  transition: background 0.2s ease;\n}\n\n.job-postings-retry-button:hover {\n  background: #b91c1c;\n}\n\n.job-postings-results {\n  padding: 0;\n}\n\n.job-postings-results-header {\n  padding: 1.5rem 2rem 1rem 2rem;\n  border-bottom: 1px solid #e2e8f0;\n  background: #f8fafc;\n}\n\n.job-postings-results-header h3 {\n  margin: 0;\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: #374151;\n}\n\n.job-postings-load-more-container {\n  padding: 1.5rem 2rem 2rem 2rem;\n  display: flex;\n  justify-content: center;\n  background: #f8fafc;\n  border-top: 1px solid #e2e8f0;\n}\n\n.job-postings-load-more {\n  background: linear-gradient(135deg, #1b2c5a 0%, #162844 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 0.75rem 1.5rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.job-postings-load-more:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(27, 44, 90, 0.3);\n}\n\n.job-postings-load-more:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.job-postings-list {\n  padding: 1.5rem 2rem 2rem 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.job-posting-card {\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  padding: 2rem;\n  margin-bottom: 1.5rem;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05), 0 1px 3px rgba(0, 0, 0, 0.1);\n  position: relative;\n  overflow: hidden;\n}\n\n.job-posting-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #d5a32a 0%, #f2c94c 100%);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.job-posting-card:hover {\n  border-color: #d5a32a;\n  box-shadow: 0 8px 25px rgba(213, 163, 42, 0.15), 0 4px 12px rgba(0, 0, 0, 0.1);\n  transform: translateY(-4px);\n}\n\n.job-posting-card:hover::before {\n  opacity: 1;\n}\n\n.job-posting-card-header {\n  margin-bottom: 1.5rem;\n}\n\n.job-posting-main-info {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 1rem;\n}\n\n.job-posting-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 1rem;\n}\n\n.job-posting-title-section {\n  flex: 1;\n}\n\n.job-posting-title {\n  margin: 0 0 0.5rem 0;\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #1f2937;\n  line-height: 1.3;\n}\n\n.job-posting-company {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #1b2c5a;\n  margin-bottom: 0.5rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.job-posting-badges {\n  display: flex;\n  gap: 0.75rem;\n  align-items: center;\n}\n\n.job-posting-distance-badge {\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n  color: #475569;\n  padding: 0.5rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 0.375rem;\n  border: 1px solid #cbd5e1;\n}\n\n.job-posting-featured-badge {\n  background: linear-gradient(135deg, #d5a32a 0%, #f2c94c 100%);\n  color: white;\n  padding: 0.5rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 0.375rem;\n  box-shadow: 0 2px 4px rgba(213, 163, 42, 0.3);\n  cursor: help;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n  white-space: nowrap;\n}\n\n.job-posting-featured-badge:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(213, 163, 42, 0.4);\n}\n\n.job-posting-badge {\n  background: linear-gradient(135deg, #1b2c5a 0%, #162844 100%);\n  color: white;\n  padding: 0.5rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  white-space: nowrap;\n  margin-left: 1rem;\n}\n\n.job-posting-meta-info {\n  display: flex;\n  gap: 1.5rem;\n  margin-bottom: 1rem;\n  flex-wrap: wrap;\n}\n\n.job-posting-meta-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #6b7280;\n  font-size: 0.875rem;\n}\n\n.job-posting-meta-item svg {\n  opacity: 0.7;\n}\n\n.job-posting-description {\n  margin-bottom: 1.5rem;\n  background: #f8fafc;\n  border-radius: 12px;\n  padding: 1.5rem;\n  border: 1px solid #e2e8f0;\n}\n\n.job-posting-description-header {\n  margin-bottom: 1rem;\n}\n\n.job-posting-description-header h5 {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #1b2c5a;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.job-posting-description-header h5::before {\n  content: '📋';\n  font-size: 1.125rem;\n}\n\n.job-posting-description-content {\n  color: #4b5563;\n  line-height: 1.6;\n}\n\n.job-posting-description-content p {\n  margin: 0;\n  font-size: 0.95rem;\n}\n\n.job-posting-description p.expanded {\n  display: block;\n}\n\n.job-posting-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n}\n\n.job-posting-secondary-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.job-posting-save-button,\n.job-posting-share-button {\n  padding: 0.75rem;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  color: #64748b;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.job-posting-save-button:hover,\n.job-posting-share-button:hover {\n  background: #e2e8f0;\n  color: #475569;\n  border-color: #cbd5e1;\n  transform: translateY(-1px);\n}\n\n.job-posting-save-button.saved {\n  background: linear-gradient(135deg, #d5a32a 0%, #f2c94c 100%);\n  color: white;\n  border-color: #d5a32a;\n}\n\n.job-posting-save-button.saved:hover {\n  background: linear-gradient(135deg, #f2c94c 0%, #d5a32a 100%);\n  color: white;\n  border-color: #f2c94c;\n  transform: translateY(-1px);\n}\n\n.job-posting-apply-button {\n  background: linear-gradient(135deg, #d5a32a 0%, #f2c94c 100%);\n  color: white;\n  text-decoration: none;\n  padding: 0.875rem 2rem;\n  border-radius: 12px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 4px 12px rgba(213, 163, 42, 0.3);\n  border: none;\n  cursor: pointer;\n}\n\n.job-posting-apply-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(213, 163, 42, 0.4);\n  background: linear-gradient(135deg, #f2c94c 0%, #d5a32a 100%);\n  text-decoration: none;\n  color: white;\n}\n\n.job-posting-apply-button:active {\n  transform: translateY(0);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .job-postings-modal-overlay {\n    padding: 0.25rem;\n  }\n\n  .job-postings-modal {\n    max-width: 100vw;\n    max-height: 99vh;\n    margin: 0;\n    border-radius: 8px;\n    height: 99vh;\n  }\n  \n  .job-postings-modal-header {\n    padding: 0.5rem;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.25rem;\n    flex-shrink: 0;\n  }\n\n  .job-postings-modal-title {\n    width: 100%;\n    gap: 0.75rem;\n  }\n\n  .job-postings-title-icon {\n    width: 28px;\n    height: 28px;\n    border-radius: 6px;\n  }\n\n  .job-postings-title-icon svg {\n    width: 14px;\n    height: 14px;\n  }\n  \n  .job-postings-title-content h2 {\n    font-size: 1rem;\n  }\n\n  .job-postings-modal-subtitle {\n    font-size: 0.7rem;\n    margin: 0.15rem 0 0 0;\n  }\n\n  .job-postings-header-actions {\n    width: 100%;\n    justify-content: space-between;\n    gap: 0.25rem;\n  }\n\n  .job-postings-modal-close,\n  .job-postings-view-saved-button {\n    padding: 0.35rem 0.75rem;\n    font-size: 0.65rem;\n    flex: 1;\n    justify-content: center;\n  }\n\n  .job-postings-download-button {\n    padding: 0.35rem 0.75rem;\n    font-size: 0.65rem;\n    flex: 1;\n    justify-content: center;\n  }\n  \n  .job-postings-modal-filters {\n    padding: 0.25rem 0.5rem;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0.25rem;\n    flex-shrink: 0;\n    transition: all 0.3s ease;\n    background: #f8fafc;\n    border-bottom: 1px solid #e2e8f0;\n  }\n\n  /* Minimized filters when scrolling */\n  .job-postings-modal-filters.minimized {\n    padding: 0.25rem 0.75rem;\n    gap: 0.25rem;\n    position: sticky;\n    top: 0;\n    z-index: 10;\n    backdrop-filter: blur(8px);\n    background: rgba(248, 250, 252, 0.95);\n    border-bottom: 1px solid rgba(226, 232, 240, 0.8);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  }\n\n  .job-postings-modal-filters.minimized .job-postings-filter-group {\n    display: none;\n  }\n\n  .job-postings-modal-filters.minimized .job-postings-filter-group:first-child,\n  .job-postings-modal-filters.minimized .job-postings-filter-group:last-child {\n    display: flex;\n  }\n\n  .job-postings-modal-filters.minimized .job-postings-filter-group:first-child {\n    flex-direction: row;\n    gap: 0.5rem;\n    align-items: center;\n  }\n\n  .job-postings-modal-filters.minimized .job-postings-filter-group:first-child label {\n    font-size: 0.7rem;\n    margin: 0;\n  }\n\n  .job-postings-modal-filters.minimized .job-postings-filter-group:first-child input {\n    width: 60px;\n    padding: 0.25rem 0.5rem;\n    font-size: 0.7rem;\n  }\n\n  .job-postings-modal-filters.minimized .job-postings-filter-group:first-child span {\n    font-size: 0.7rem;\n  }\n\n  .job-postings-modal-filters.minimized .job-postings-search-button {\n    padding: 0.4rem 0.8rem;\n    font-size: 0.7rem;\n    width: auto;\n    flex: 0 0 auto;\n  }\n\n  .job-postings-filter-group {\n    min-width: auto;\n  }\n\n  .job-postings-filter-group label {\n    font-size: 0.65rem;\n  }\n\n  .job-postings-filter-input,\n  .job-postings-filter-select {\n    padding: 0.35rem 0.5rem;\n    font-size: 0.7rem;\n  }\n\n  .job-postings-search-button {\n    padding: 0.4rem 0.75rem;\n    font-size: 0.7rem;\n    width: 100%;\n    justify-content: center;\n  }\n\n  .job-postings-results-header {\n    padding: 0.5rem;\n    flex-shrink: 0;\n  }\n\n  .job-postings-results-header h3 {\n    font-size: 0.8rem;\n  }\n  \n  .job-postings-list {\n    padding: 0.25rem;\n    gap: 0.25rem;\n    flex: 1;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  \n  .job-posting-card {\n    padding: 0.5rem;\n    border-radius: 6px;\n    margin-bottom: 0;\n    flex-shrink: 0;\n  }\n\n  .job-posting-card-header {\n    margin-bottom: 0.5rem;\n  }\n\n  .job-posting-main-info {\n    flex-direction: column;\n    gap: 0.25rem;\n    margin-bottom: 0.25rem;\n  }\n\n  .job-posting-title {\n    font-size: 0.9rem;\n    margin: 0 0 0.2rem 0;\n  }\n\n  .job-posting-company {\n    font-size: 0.75rem;\n    margin-bottom: 0.2rem;\n  }\n\n  .job-posting-badges {\n    gap: 0.25rem;\n    flex-wrap: wrap;\n  }\n\n  .job-posting-distance-badge,\n  .job-posting-featured-badge,\n  .job-posting-badge {\n    font-size: 0.6rem;\n    padding: 0.2rem 0.4rem;\n    margin-left: 0;\n  }\n  \n  .job-posting-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n  \n  .job-posting-badge {\n    margin-left: 0;\n    align-self: flex-start;\n  }\n  \n  .job-posting-meta-info {\n    flex-direction: column;\n    gap: 0.25rem;\n    margin-bottom: 0.5rem;\n  }\n\n  .job-posting-meta-item {\n    font-size: 0.65rem;\n  }\n\n  .job-posting-meta-item svg {\n    width: 12px;\n    height: 12px;\n  }\n\n  .job-posting-description {\n    padding: 0.5rem;\n    margin-bottom: 0.5rem;\n  }\n\n  .job-posting-description-header h5 {\n    font-size: 0.75rem;\n  }\n\n  .job-posting-description-content p {\n    font-size: 0.7rem;\n    line-height: 1.4;\n  }\n  \n  .job-posting-actions {\n    flex-direction: column-reverse;\n    gap: 0.25rem;\n  }\n\n  .job-posting-secondary-actions {\n    width: 100%;\n    gap: 0.25rem;\n  }\n\n  .job-posting-save-button,\n  .job-posting-share-button {\n    flex: 1;\n    padding: 0.4rem;\n  }\n\n  .job-posting-save-button svg,\n  .job-posting-share-button svg {\n    width: 14px;\n    height: 14px;\n  }\n  \n  .job-posting-apply-button {\n    width: 100%;\n    justify-content: center;\n    padding: 0.5rem 1rem;\n    font-size: 0.75rem;\n  }\n\n  .job-postings-load-more-container {\n    padding: 0.75rem;\n  }\n\n  .job-postings-load-more {\n    width: 100%;\n    justify-content: center;\n    padding: 0.5rem 1rem;\n    font-size: 0.75rem;\n  }\n\n  .job-postings-powered-by {\n    margin-right: 0.25rem;\n  }\n\n  .job-postings-logo {\n    height: 40px;\n    max-width: 200px;\n  }\n\n  .radius-tooltip {\n    width: calc(100vw - 3rem) !important;\n    max-width: 280px !important;\n    font-size: 0.75rem !important;\n    padding: 0.75rem !important;\n  }\n}\n\n/* Saved Jobs Styling */\n.job-postings-saved-subtitle {\n  margin: 0.25rem 0 0 0;\n  font-size: 0.875rem;\n  opacity: 0.8;\n  font-weight: 400;\n}\n\n.job-posting-saved-badge {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white;\n  padding: 0.5rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 0.375rem;\n  box-shadow: 0 2px 4px rgba(16, 185, 129, 0.3);\n}\n\n.saved-job-card {\n  border-left: 4px solid #10b981;\n}\n\n.saved-job-card::before {\n  background: linear-gradient(90deg, #10b981 0%, #059669 100%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
